var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSentInterviews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "translate(-138.000000, -89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/_Send-Interviews---24",
    transform: "translate(138.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(3.000000, 1.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "users",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.56640625,9.6 C3.72481641,9.6 2.2265625,8.16448 2.2265625,6.4 C2.2265625,4.63552 3.72481641,3.2 5.56640625,3.2 C7.40799609,3.2 8.90625,4.63552 8.90625,6.4 C8.90625,8.16448 7.40799609,9.6 5.56640625,9.6 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1328125,16 L0,16 L0,14.9333333 C0,11.9925333 2.49708984,9.6 5.56640625,9.6 C8.75699609,9.6 11.1328125,12.09728 11.1328125,14.9333333 L11.1328125,16 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4335938,6.4 C11.5920039,6.4 10.09375,4.96448 10.09375,3.2 C10.09375,1.43552 11.5920039,0 13.4335938,0 C15.2751836,0 16.7734375,1.43552 16.7734375,3.2 C16.7734375,4.96448 15.2751836,6.4 13.4335938,6.4 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.4335938,6.4 C11.3265977,6.4 9.48215039,7.52579556 8.53764258,9.19441778 C9.20204883,9.51047111 9.8123125,9.93511111 10.3444238,10.4597333 C11.0319863,11.1376356 11.546248,11.9349333 11.8655,12.7999644 L19,12.7999644 L19,11.7332978 C19,8.79253333 16.5029102,6.4 13.4335938,6.4 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.9229649 22 19 18.5017093 13.9229649 15 13.9229649 17.1872863 11 17.1872863 11 19.8127137 13.9229649 19.8127137"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentInterviews);
export default __webpack_public_path__ + "static/media/sent-interviews.65d22431e345610bae7a5b3792691859.svg";
export { ForwardRef as ReactComponent };